// src/components/Login.jsx
import React, { useState, useContext } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import '../css/login.css'
import logo from '../assets/logo.png'
import { AuthContext } from '../contexts/AuthContext'
import { getFirstAllowedRoute } from './Utils/firstAllowedRoute'

const Login = () => {
  const [email, setEmail]       = useState('')
  const [password, setPassword] = useState('')
  const [error, setError]       = useState('')
  const [loading, setLoading]   = useState(false)
  const navigate   = useNavigate()
  const location   = useLocation()
  const { login: contextLogin } = useContext(AuthContext)

  const handleSubmit = async e => {
    e.preventDefault()
    if (loading) return
    setError('')
    setLoading(true)

    try {
      const loggedUser = await contextLogin(email, password)
      const hasPerm = (p) => (loggedUser?.permissions || []).includes(p)

      const from = location.state?.from?.pathname
      const dest = from || getFirstAllowedRoute(hasPerm)
      navigate(dest, { replace: true })
    } catch (err) {
      if (err?.response?.status === 429) {
        setError('Troppi tentativi, attendi qualche secondo e riprova.')
      } else {
        setError('Credenziali non valide.')
      }
      setLoading(false)
    }
  }

  return (
    <div className="container">
      <img src={logo} alt="Logo" className="logo"/>
      <h2>Accedi</h2>
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? 'Accesso in corso…' : 'Accedi'}
        </button>
      </form>
    </div>
  )
}

export default Login
